import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FunctionsService } from 'src/app/services/functions.service';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { AppConstants } from 'src/app/app.constants';
import * as _moment from 'moment';
import * as XLSX from 'xlsx';
import { TranslateService } from '@ngx-translate/core';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
const moment = _moment;

@Component({
  selector: 'app-export-alert-history',
  templateUrl: './export-alert-history.component.html',
  styleUrls: ['./export-alert-history.component.css'],
  providers: [NgxSpinnerService, {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: AppConstants.MY_FORMATS}
  ]
})

export class ExportAlertHistoryComponent implements OnInit {
  constructor(
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    public functionsService: FunctionsService,
    private apiService: ApiService,
    private dateAdapter: DateAdapter<Date>,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal) { }

  get monthYear() { return this.controlGetter('MonthYear'); }
  get alertTypeName() { return this.controlGetter('AlertTypeName'); }
  get falseAlert() { return this.controlGetter('FalseAlert'); }
  get canceled() { return this.controlGetter('Canceled'); }
  get late() { return this.controlGetter('Late'); }
  get groupName() { return this.controlGetter('GroupName'); }

  language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
  my = new UntypedFormControl(moment());
  selectedMonth;
  selectedYear;
  selectedMY = ((new Date()).getMonth()+1) + "-" + (new Date()).getFullYear();
  minDate: Date;
  maxDate: Date;
  realFalseArray = [{id: 3, status:"all"}, {id: 2, status:"out_of_zone_alerts"}, {id:1, status:"false_alerts"}, {id:0, status:"real_alerts"}];
  defaultStatus = {id: 3} 
  canceledArray = [{id: 2, status:"all"}, {id: 1, status:"canceled_alerts"}, {id:0, status:"not_canceled_alerts"}];
  defaultCanceled = {id: 2};
  defaultAlertType = {name: "-"};
  alertTypes;
  defaultGroup = {name: "-"};
  groups;
  lateArray = [{id: 2, status:"all"}, {id: 1, status:"alert.late"}, {id:0, status:"alert.not-late"}];
  defaultLate = {id: 2};
  

  formSubmitted: boolean = false;
  exportHistoryForm = this.formBuilder.group({
    monthYear: ['',moment()],
    alertTypeName: [''],
    status: [''],
    canceled: [''],
    late: [''],
    groupName: ['']
  });

  ngOnInit() {
    this.dateAdapter.setLocale(this.language); 
    this.maxDate = new Date(); 
    this.getSubscriptionStartDate();
    this.fetchAlertTypes();
    this.fetchAlertGroups();
    this.spinner.show();
  }

  fetchAlertTypes() {
    this.apiService.getOpenClosedAlertTypes(1).subscribe(resp => {
        this.alertTypes = resp;
        this.spinner.hide();
    }, err => {
        console.error(err);
        this.spinner.hide();
    });
  }

  fetchAlertGroups(){
    this.spinner.show();
        this.apiService.getClosedAlertGroups().subscribe(resp => {
            this.groups = resp; 
        }, err => {
            console.error(err);
            this.spinner.hide();
        });
  }
  
  exportData() {
    this.exportHistoryForm.value["monthYear"] = this.selectedMY;
    this.spinner.show();
    this.exportHistoryForm.value["timeZone"] = (-1)*(new Date().getTimezoneOffset()/60);
    this.apiService.alertHistoryExport(this.exportHistoryForm.value).subscribe(
      data => {
        let jsonString = JSON.stringify(data);
        let jsonObject = JSON.parse(jsonString);
        if(jsonObject.length>0){ 
          const fileName = `SA-${this.selectedMY}.csv`;
          var dataArray = [];
          
          if(this.language=="es"){
            var date = this.exportHistoryForm.value['monthYear'];
            var type = this.exportHistoryForm.value['alertTypeName'] == "-"? "Todas": this.exportHistoryForm.value['alertTypeName'];
            var canceled = this.exportHistoryForm.value['canceled'] == 1? "Canceladas" : this.exportHistoryForm.value['canceled'] == 2? "Todas" : "No Canceladas";
            var closedAs = this.exportHistoryForm.value['status'] == 3? "Todas": this.exportHistoryForm.value['status'] == 2? "Alertas Fuera de Zona" : this.exportHistoryForm.value['status'] == 1? "Alertas Falsas" : "Alertas Atendidas";
            var late = this.exportHistoryForm.value['late'] == 1? "Tarde" : this.exportHistoryForm.value['status'] == 0? "No Tarde" : "Todas";
            var group = this.exportHistoryForm.value['groupName'] == "-"? "Todas": this.exportHistoryForm.value['groupName'];
            var heading = [["Mes y Año: " + date + ", " + "Tipo de Alerta: " + type + ", " + "Cerrada Como: " + closedAs + ", " +  "Canceladas/No Canceladas: " + canceled + ", " + "Tarde: " + late + ", " + "Grupo: " + group]]
            jsonObject.forEach(element => {
              var closed_as = (element.falseAlert === 1)?(this.translate.instant('alert.false_alert')):(element.offZone>0?this.translate.instant('alert.out_of_zone'):this.translate.instant('alert.attended'));
              dataArray.push({"Id":element.id,"Tipo":element.alertTypeName,"Creada Por":(element.createdByName),"Cerrada Por":(element.closedByName),"Fecha de Creación": this.functionsService.convertUTCDateToLocalDate(element.createdDate),"Cerrada El":this.functionsService.convertUTCDateToLocalDate(element.closedDate),"Cancelada": (element.canceled?"Sí":"No"),"Tarde":(element.late == "True"?"Sí":"No"), "Cerrada Como":closed_as});
            });
          } else {
            var date = this.exportHistoryForm.value['monthYear'];
            var type = this.exportHistoryForm.value['alertTypeName'] == "-"? "All": this.exportHistoryForm.value['alertTypeName'];
            var canceled = this.exportHistoryForm.value['canceled'] == 1? "Canceled" : this.exportHistoryForm.value['canceled'] == 2? "All" : "Not Canceled";
            var closedAs = this.exportHistoryForm.value['status'] == 3? "All": this.exportHistoryForm.value['status'] == 2? "Out of Zone Alerts" : this.exportHistoryForm.value['status'] == 1? "False Alerts" : "Attended Alerts";
            var late = this.exportHistoryForm.value['late'] == 1? "Late" : this.exportHistoryForm.value['status'] == 0? "Not Late" : "All";
            var group = this.exportHistoryForm.value['groupName'] == "-"? "All": this.exportHistoryForm.value['groupName'];
            var heading = [["Month and Year: " + date + ", " + "Alert Type: " + type + ", " + "Closed As: " + closedAs + ", " + "Canceled/ Not Canceled: " + canceled + ", " + "Late: " + late + ", " + "Group: " + group]]
            jsonObject.forEach(element => {
              var closed_as = (element.falseAlert === 1)?(this.translate.instant('alert.false_alert')):(element.offZone>0?this.translate.instant('alert.out_of_zone'):this.translate.instant('alert.attended'));
              dataArray.push({"Id":element.id,"Type":element.alertTypeName,"Created By":(element.createdByName),"Closed By":(element.closedByName),"Date Created": this.functionsService.convertUTCDateToLocalDate(element.createdDate),"Closed On":this.functionsService.convertUTCDateToLocalDate(element.closedDate),"Canceled": (element.canceled?"Yes":"No"), "Late":(element.late == "True"?"Yes":"No"), "Closed As":closed_as});
            });
          }
          dataArray.push({})
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_aoa(ws, heading);
          XLSX.utils.sheet_add_json(ws, dataArray, {origin: 'A2'});
          XLSX.utils.book_append_sheet(wb, ws, 'SA');
          XLSX.writeFile(wb, fileName);
        }
        else{
          const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
            modalRef.componentInstance.title = "Error";
            modalRef.componentInstance.message = this.translate.instant('general.no_data_avail_date');
        }
        this.spinner.hide();
        this.activeModal.close();
      },
      error => {
        this.spinner.hide();
        this.functionsService.errorHandler(error["status"]);
      }
    );
  }

  chosenYear(normalizedYear: _moment.Moment) {
    this.selectedYear = normalizedYear.year();
    const ctrlValue = this.my.value;
    ctrlValue.year(normalizedYear.year());
    this.my.setValue(ctrlValue);
  }

  chosenMonth(normalizedMonth: _moment.Moment, datepicker: MatDatepicker<_moment.Moment>) {
    this.selectedMonth = normalizedMonth.month() + 1;
    this.selectedMY = this.selectedMonth + "-" + this.selectedYear;
    const ctrlValue = this.my.value;
    ctrlValue.month(normalizedMonth.month());
    this.my.setValue(ctrlValue);
    datepicker.close();
  }

  getSubscriptionStartDate(){
    this.apiService.subscriptionStartDate().subscribe(
        data => {
            this.minDate = new Date(data.toString());
        },
        error => {
            this.minDate = new Date();
        }
    );
  }

  controlGetter(controlName) {
    const control =  this.exportHistoryForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}